<script setup lang="ts">
defineProps<{
    onboardingCommunication: string;
}>();
</script>

<template>
  <div class="flex gap-2 items-end">
    <div class="text-end flex justify-end flex-1 pb-2">
      <p class="max-w-2xl text-primary text-sm">
        {{ onboardingCommunication }}
      </p>
    </div>
    <div class="h-16 overflow-hidden self-end px-2">
      <img
        src="@/assets/images/gamification-level-5.png"
        class="object-contain w-24 rotate-[15deg] drop-shadow-xl shrink-0"
        alt="Gamification level 5 achievement badge"
      >
    </div>
  </div>
</template>

<style scoped>

</style>
